import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "manage-account-modal" }
const _hoisted_2 = { class: "modal-title" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pointer-sub bi-dash-circle-fill text-danger" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi-plus-lg" }, null, -1)
const _hoisted_9 = { class: "pointer-sub ms-2" }
const _hoisted_10 = { class: "d-flex p-4 flex-row-reverse" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MrUiKitInput = _resolveComponent("MrUiKitInput")!
  const _component_MrUiKitAddField = _resolveComponent("MrUiKitAddField")!
  const _component_MrUiKitButton = _resolveComponent("MrUiKitButton")!
  const _component_MrUiKitModal = _resolveComponent("MrUiKitModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MrUiKitModal, { onClose: _ctx.onClose }, {
      header: _withCtx(() => [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.t("common.modals.manageAccount.title")), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_MrUiKitAddField, {
          modelValue: _ctx.accounts,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accounts) = $event)),
          template: _ctx.template,
          fieldClasses: ['d-flex']
        }, {
          default: _withCtx(({ index }) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_MrUiKitInput, {
                modelValue: _ctx.accounts[index].email,
                "onUpdate:modelValue": ($event: any) => ((_ctx.accounts[index].email) = $event),
                key: index
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ])
          ]),
          "button-remove": _withCtx(({ click }) => [
            _createElementVNode("div", {
              class: "mt-2 ms-2 button-remove",
              onClick: click
            }, _hoisted_6, 8, _hoisted_4)
          ]),
          "button-add": _withCtx(({ click }) => [
            _createElementVNode("div", {
              onClick: click,
              class: "pointer-sub text-primary button-add"
            }, [
              _hoisted_8,
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t('common.fields.addAccount')), 1)
            ], 8, _hoisted_7)
          ]),
          _: 1
        }, 8, ["modelValue", "template"]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_MrUiKitButton, { onClick: _ctx.onSave }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('common.operations.save')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["onClose"])
  ]))
}